export default __webpack_public_path__ + "static/media/dundleySL.fd02ec22.jpg";